<div class="row">
    <div
        class="col-4 col-sm-3 col-md-2 col-lg-4 pr-0"
        [class.d-none]="hideMobileThumbnail"
        [class.d-md-flex]="hideMobileThumbnail"
    >
        <img
            *ngIf="pitch.data.attributes.images.small.length"
            class="thumbnail"
            [src]="pitch.data.attributes.images.small[0]"
            alt="thumbnail"
        />
    </div>

    <div
        class="col-8 col-sm-9 col-md-10 col-lg-8 pr-4"
        [class.col-12]="hideMobileThumbnail"
        [class.col-md-10]="hideMobileThumbnail"
    >
        <h5 class="sg-heading__h5 font-weight-medium sg-color -sgPrimary mb-1">
            {{ pitch.data.attributes.name }}
        </h5>
        <span
            class="small subheading d-sm-block"
            [class.d-block]="modal"
            [class.d-none]="!modal"
            >{{ venue | venueInlineAddress }}</span
        >

        <div
            class="row d-none d-lg-none sg-color align-bottom"
            [class.d-sm-none]="modal"
            [class.d-sm-flex]="!modal"
        >
            <ng-content *ngTemplateOutlet="priceShowDetails"></ng-content>
        </div>
    </div>
</div>

<div class="row d-sm-none mt-3" [class.d-none]="modal">
    <span class="pl-3 mb-2 small subheading">{{
        venue | venueInlineAddress
    }}</span>

    <ng-content *ngTemplateOutlet="priceShowDetails"></ng-content>
</div>

<div
    class="row mt-2 px-3 d-lg-none booking-details py-2"
    [@ngForAnimationFold]="detailsShowing ? 'opened' : 'closed'"
>
    <ng-content *ngTemplateOutlet="bookingDetails"></ng-content>

    <div
        *ngIf="!paid"
        class="col-12 my-3 mt-md-2 col-md-7 booking-details__divider"
    >
        <pf-discount
            *ngIf="authService.sessionChecked | async"
            [slot]="slot"
            [guest]="guestDetails"
        ></pf-discount>
    </div>
</div>

<div
    class="row mt-0 mt-lg-4 d-lg-flex"
    [class.d-flex]="modal"
    [class.d-none]="!modal"
>
    <ng-content *ngTemplateOutlet="bookingDetails"></ng-content>
</div>

<div
    class="row mt-3 px-3 d-lg-flex"
    [class.d-flex]="modal"
    [class.d-none]="!modal"
>
    <div class="col-6 pl-0 py-3 price sg-color" [class.paid]="paid">
        <p *ngIf="paid" class="m-0">Total Paid:</p>
        <p *ngIf="!paid" class="m-0">Price:</p>
    </div>

    <div class="col-6 py-3 pr-0 text-right price" [class.paid]="paid">
        {{
            (paid ? paid : slot.attributes.price)
                | currency: slot.attributes.currency
        }}
    </div>
</div>

<ng-template #priceShowDetails>
    <div class="col-6 sg-color">
        Price:
        {{
            (paid ? paid : slot.attributes.price)
                | currency: slot.attributes.currency
        }}
    </div>

    <div class="col-6 text-right sg-color small">
        <span class="cursor" (click)="detailsShowing = !detailsShowing">
            <mlp-ng-icon name="add"></mlp-ng-icon>

            {{ detailsShowing ? "Less Detail" : "More Detail" }}
        </span>
    </div>
</ng-template>

<ng-template #bookingDetails>
    <div [class.col-md-5]="!paid" class="col-12 col-lg-12 mt-2">
        <p class="description mb-0 text-capitalize">
            <strong>Sport:</strong> {{ pitch.data.attributes.sport }}
        </p>
        <p class="description mb-0">
            <strong>Format & Surface:</strong>
            {{ pitch.data | sportFormatSurfaceText }}
        </p>

        <div class="my-2">
            <div class="sg-divider__short"></div>
        </div>

        <p class="description mb-0">
            <strong>Date:</strong>
            <span
                [innerHTML]="
                    slot.attributes.starts
                        | momentTimezone: 'eee, d\'o\' MMMM yyyy':true
                "
            ></span>
        </p>
        <p class="description mb-0">
            <strong>Time:</strong>
            {{ slot.attributes.starts | momentTimezone: "HH:mm" }}
        </p>
        <p class="description mb-0">
            <strong>Duration:</strong>
            {{
                slot.attributes.starts
                    | differenceInMinutes: slot.attributes.ends
            }}
            min
        </p>
    </div>
</ng-template>
